<template>
  <div>
    <p v-if="!hideTitle">{{ drug.title }}</p>
    <p v-if="+drug.pack_set !== 1">Комплект: <strong>{{ +drug.pack_set }}</strong> з.у.</p>
    <div class="alert alert-info" v-if="drug.pack_comment || drug.pack_box_comment">
      <p v-if="drug.pack_comment">{{ drug.pack_comment }}</p>
      <p v-if="drug.pack_box_comment">{{ drug.pack_box_comment }}</p>
    </div>
    <p v-if="!hideRemain">Доступный остаток на складе: <strong>{{ drug.remain || 0 }}</strong> з.у.</p>
    <div class="flex">
      <div class="form-group" style="flex-grow: 0">
        <p>
          <template v-if="(+drug.pack_set) !== 1">
            Комплектов: <strong>{{ calculatedPackSet }}</strong>
          </template>&nbsp;
        </p>
        <label for="">Количество (з.у.)</label>
        <input @keyup="updatePackSet" v-model="newData.new_qty" type="number" placeholder="новое количество"
               class="form-control"/>
      </div>
      <div class="form-group" style="flex-grow: 1">
        <p>&nbsp;</p>
        <label for="">Комментарий</label>
        <input v-model="newData.comment" placeholder="причина изменения" type="text" class="form-control"/>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['drug', 'hideRemain', 'hideTitle'],
  data() {
    return {
      calculatedPackSet: 0,
      newData: {
        new_qty: 0,
        comment: null
      }
    }
  },
  mounted() {
    this.newData.new_qty = this.drug.new_qty;
    if (this.drug.new_qty != 0 && !this.drug.new_qty) {
      this.newData.new_qty = this.drug.qty;
    }
    this.newData.comment = this.drug.comment;
    this.updatePackSet(null);
  },
  methods: {
    updatePackSet(e) {
      if (+this.newData.new_qty) {
        this.calculatedPackSet = Math.round(+this.newData.new_qty / +this.drug.pack_set * 10) / 10
      } else {
        this.calculatedPackSet = 0
      }
    }
  }
}

</script>

<style scoped>
p {
  margin-bottom: 10px;
}

.alert {
  margin-bottom: 10px;
}
</style>
